<nav class="navbar navbar-light bg-light border-bottom">
  <a class="navbar-brand" href="/">
    Cilor DB
    <ng-container *ngIf="version != null">
      {{version}}
    </ng-container>
  </a>

  <div class="flex-spacer"></div>

  <a
    href="javascript:;"
    class="navbar-item"
    (click)="supportService.showSupportWindow()"
  >
    Support
  </a>

  <button
    class="btn btn-sm btn-outline-secondary"
    type="button"
    *ngIf="authService.isLoggedIn()"
    (click)="logout()"
  >
    Logout
  </button>
</nav>
